export function getIrisDialogUrl(value: unknown): string | undefined {
    if (typeof value !== 'string' || /[\u0000-\u001f\u007f]/.test(value)) {
        return undefined;
    }
    try {
        const url = new URL(value.trim());
        return url.protocol === 'https:' && !url.username && !url.password ? url.href : undefined;
    } catch {
        return undefined;
    }
}

export function getIrisDialogTrackingUrl(value: unknown): string | undefined {
    return typeof value === 'string' && getIrisDialogUrl(value) ? value.trim() : undefined;
}
